function notificationCoordinates(position) {
  const parts = position.split("-");
  const coordinates = {
    top: "",
    left: "",
    right: "",
    bottom: "",
  };

  if (parts.includes("top")) coordinates.top = "0px";
  if (parts.includes("bottom")) coordinates.bottom = "0px";
  if (parts.includes("right")) coordinates.right = "0px";
  if (parts.includes("left")) coordinates.left = "0px";
  if (parts.includes("center")) coordinates.left = "50%";
  return coordinates;
}

function moveNotifications(position) {
  const notifications = document.querySelectorAll(`.vs-noti-${position}`);

  notifications.forEach((notification, index) => {
    let offset = 10;
    for (let previous = 0; previous < index; previous += 1) {
      offset += notifications[previous].clientHeight + 6;
    }

    if (!position.includes("center")) {
      notification.style.transform = position.includes("top")
        ? `translateY(${offset}px)`
        : `translateY(-${offset}px)`;
    } else if (position.includes("top")) {
      notification.style.transform = `translate(-50%,${offset}px)`;
      notification.style.zIndex = 10000 - index;
    } else {
      notification.style.transform = `translate(-50%,-${offset}px)`;
      notification.style.zIndex = 10000 - index;
    }
  });
}

function createIcon(icon, iconPack) {
  const element = document.createElement("i");
  element.className = [
    "vs-icon",
    "notranslate",
    "icon-scale",
    "vs-icon-noti",
    iconPack,
    iconPack !== "material-icons" ? icon : "",
  ]
    .filter(Boolean)
    .join(" ");
  if (iconPack === "material-icons") element.textContent = icon;
  return element;
}

function closeNotification(notification, position) {
  if (!notification || notification.dataset.closing === "true") return;
  notification.dataset.closing = "true";
  notification.classList.remove("activeNoti");
  notification.style.opacity = "0";

  const exitsVertically =
    position.includes("center") ||
    notification.style.width === "calc(100% - 14px)";
  const direction = position.includes("left") ? "-" : "";
  const verticalDirection = position.includes("top") ? "-" : "";
  notification.style.transform += exitsVertically
    ? ` translateY(${verticalDirection}100%)`
    : ` translateX(${direction}100%)`;

  setTimeout(() => {
    notification.remove();
    moveNotifications(position);
  }, 150);
}

function createNotification(parameters = {}) {
  const fullWidth = Boolean(parameters.fullWidth);
  let position = parameters.position || "bottom-right";
  if (fullWidth) position = position.replace("right", "left");

  const color = parameters.color || "primary";
  const colorText = parameters.colorText || "rgb(255, 255, 255)";
  const time = parameters.time === undefined ? 3000 : parameters.time;
  const coordinates = notificationCoordinates(position);

  const notification = document.createElement("div");
  notification.className = [
    "vs-component",
    "vs-notifications",
    `vs-noti-${position}`,
    `vs-noti-${color}`,
    "activeNoti",
  ].join(" ");
  Object.assign(notification.style, coordinates, {
    color: colorText,
    width: fullWidth ? "calc(100% - 14px)" : "",
    maxWidth: fullWidth ? "none" : "350px",
    opacity: "0",
  });

  const content = document.createElement("div");
  content.className = "content-noti";
  const textContainer = document.createElement("div");
  textContainer.className = "con-text-noti";

  const title = document.createElement("h3");
  title.innerHTML = parameters.title || "";
  textContainer.appendChild(title);

  const text = document.createElement("p");
  text.innerHTML = parameters.text || "";
  textContainer.appendChild(text);
  content.appendChild(textContainer);

  if (parameters.icon) {
    content.appendChild(
      createIcon(parameters.icon, parameters.iconPack || "material-icons")
    );
  }
  notification.appendChild(content);

  const filling = document.createElement("span");
  filling.className = "filling";
  filling.style.background = color;
  notification.appendChild(filling);

  notification.addEventListener("click", () => {
    closeNotification(notification, position);
    if (typeof parameters.click === "function") parameters.click();
  });

  document.body.insertBefore(notification, document.body.firstChild);
  requestAnimationFrame(() => {
    const width = notification.clientWidth;
    filling.style.left = coordinates.left ? "-100px" : "";
    filling.style.right = coordinates.right ? "-100px" : "";
    filling.style.height = `${width * 2}px`;
    filling.style.width = `${width * 2}px`;
    notification.style.opacity = "1";
    moveNotifications(position);
  });

  if (!parameters.fixed) {
    setTimeout(() => closeNotification(notification, position), time);
  }
  return notification;
}

export function installVsNotify(app, legacyVs) {
  const vs = app.config.globalProperties.$vs || legacyVs || {};
  vs.notify = (parameters) => createNotification(parameters);
  app.config.globalProperties.$vs = vs;
}
